import { WebPlugin } from '@capacitor/core';
export class AdmobAdsWeb extends WebPlugin {
    async showBannerAd(options) {
        throw new Error('Method not implemented.');
    }
    async hideBannerAd() {
        throw new Error('Method not implemented.');
    }
    async resumeBannerAd() {
        throw new Error('Method not implemented.');
    }
    async removeBannerAd() {
        throw new Error('Method not implemented.');
    }
    async loadNativeAd(options) {
        throw new Error('Method not implemented.');
    }
    async triggerNativeAd(options) {
        throw new Error('Method not implemented.');
    }
    async loadRewardedVideoAd(options) {
        throw new Error('Method not implemented.');
    }
    async showRewardedVideoAd() {
        throw new Error('Method not implemented.');
    }
    async loadRewardedInterstitialAd(options) {
        throw new Error('Method not implemented.');
    }
    async showRewardedInterstitialAd() {
        throw new Error('Method not implemented.');
    }
    async loadInterstitialAd(options) {
        throw new Error('Method not implemented.');
    }
    async showInterstitialAd() {
    }
}
//# sourceMappingURL=web.js.map